import { Modal } from '@sqs/rosetta-elements';
import React, { useState } from 'react';
import { UserAddToSchedulingInstanceModal } from '../components/Users/UserAddToSchedulingInstanceModal';
import { UserChangeUserPermissionModal } from '../components/Users/UserChangeUserPermissionModal';
import { UserRemoveUserFromSchedulingInstanceModal } from '../components/Users/UserRemoveUserFromSchedulingInstanceModal';
import { SchedulingInstancePermission, SchedulingInstancePermissionData } from '../models/SchedulingInstance';

interface UseSchedulingInstanceUserActionsProps {
  orgUserId?: number;
  refresh?: () => void;
  onClose?: () => void;
}

export const useSchedulingInstanceUserActions = ({ onClose, refresh }: UseSchedulingInstanceUserActionsProps = {}) => {
  const [showAddToSchedulingInstanceModal, setShowAddToSchedulingInstanceModal] = useState<number>(0);
  const [showRemoveUserFromSchedulingInstanceModal, setShowRemoveUserFromSchedulingInstanceModal] = useState<{
    instanceId: number;
    orgUserId: number;
  } | null>(null);
  const [showChangeUserPermissionModal, setShowChangeUserPermissionModal] = useState<
    SchedulingInstancePermissionData & { schedulingInstanceId: number; orgUserId: number }
  >();

  const closeAllModals = () => {
    if (onClose) {
      onClose();
    }
    setShowAddToSchedulingInstanceModal(0);
    setShowRemoveUserFromSchedulingInstanceModal(null);
    setShowChangeUserPermissionModal(undefined);
  };

  return {
    closeAllInstanceUserActionModals: closeAllModals,
    showRemoveUserFromSchedulingInstanceModal: (instanceId: number, orgUserId: number) =>
      setShowRemoveUserFromSchedulingInstanceModal({ instanceId, orgUserId }),
    showAddToSchedulingInstanceModal: (orgUserId: number) => setShowAddToSchedulingInstanceModal(orgUserId),
    showChangeUserPermissionModal: (
      instanceId: number,
      orgUserId: number,
      permissions?: SchedulingInstancePermissionData,
    ) => {
      const permissionData: SchedulingInstancePermissionData = {
        allCalendars: false,
        allowExports: false,
        calendars: [],
        permissions: SchedulingInstancePermission.ADMIN,
        ...permissions,
      };
      setShowChangeUserPermissionModal({
        ...permissionData,
        orgUserId,
        schedulingInstanceId: instanceId,
      });
    },
    renderInstanceUserActionModals: () => (
      <Modal.Transition>
        {showAddToSchedulingInstanceModal > 0 && (
          <UserAddToSchedulingInstanceModal
            orgUserId={showAddToSchedulingInstanceModal}
            closeModal={closeAllModals}
            refresh={refresh}
          />
        )}
        {showRemoveUserFromSchedulingInstanceModal && (
          <UserRemoveUserFromSchedulingInstanceModal
            orgUserId={showRemoveUserFromSchedulingInstanceModal.orgUserId}
            instanceId={showRemoveUserFromSchedulingInstanceModal.instanceId}
            closeModal={closeAllModals}
            refresh={refresh}
          />
        )}
        {showChangeUserPermissionModal && (
          <UserChangeUserPermissionModal
            orgUserId={showChangeUserPermissionModal.orgUserId}
            permissionData={showChangeUserPermissionModal}
            closeModal={closeAllModals}
            refresh={refresh}
          />
        )}
      </Modal.Transition>
    ),
  };
};
